import type { Prototype } from "../prototype-types";

export const andyZhenPrototypes: Prototype[] = [
  {
    id: "az-account-settings-opening-date-update",
    name: "Account Settings Opening Date Update",
    path: "/az/account-settings-opening-date-update",
    description:
      "Explore ways for retailers to view and update their business opening date from account settings.",
    owner: "Andy Zhen",
    createdAt: "2026-07-24",
    lastUpdated: "2026-07-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6c1a7f163ca262a2b1a5f29e2c7e8da44f0bd3dc201d02d40273a4b45728f4f9.png",
    creationTool: "cursor",
    project: "Opening Date Updates Post Signup",
  },
  {
    id: "az-idv-opening-date-freshness-update",
    name: "IDV Opening Date Freshness Update",
    path: "/az/idv-opening-date-freshness-update",
    description:
      "Explore progressive month selection patterns for opening-soon retailers in the IDV flow.",
    owner: "Andy Zhen",
    createdAt: "2026-07-21",
    lastUpdated: "2026-07-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ff2466a4b1817f35d0b8cc1115a1812e517ddc2912426b9a416e490a9911620c.png",
    creationTool: "cursor",
    project: "Opening Date Updates Post Signup",
  },
  {
    id: "az-opening-soon-on-brand-portal",
    name: "Opening Soon on Brand Portal",
    path: "/az/opening-soon-on-brand-portal",
    description:
      "Explore how brands can identify retailers that are opening soon.",
    owner: "Andy Zhen",
    createdAt: "2026-07-23",
    lastUpdated: "2026-07-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/7bdf25a0ba22ef605b7bdd07fc0ae3418d0cb281457e9cdb3f1ae7b84f5f7aba.png",
    creationTool: "cursor",
    project: "Opening Soon on Brand Portal",
  },
  {
    id: "az-owf-revamp",
    name: "OwF Revamp",
    path: "/az/owf-revamp",
    description:
      "Accordion-based Open with Faire application form in the live signup chrome, with section-by-section Next CTAs and complete/incomplete status.",
    owner: "Andy Zhen",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/az-owf-revamp.png",
    creationTool: "cursor",
    project: "OwF Revamp",
  },
];
